<template>
    <p class="text-muted small mt-2 mb-0" role="status">
        <span class="spinner-border me-1" style="width: .8rem; height: .8rem; border-width: .15em;" aria-hidden="true"></span>{{ getTranslatedText('__continuing__') }}
    </p>
</template>
<script setup>
// Shown under a message the form moves past on its own after a few seconds (phone verified, too
// many attempts, Flinks retries), so the step changing by itself is expected rather than a glitch.
import { inject } from 'vue';

const { getTranslatedText } = inject('app');
</script>
